export const renholdFront = (kommuneNr) => {
	return `
        <script type="text/javascript" src="https://norkartrenovasjon.azurewebsites.net/MinRenovasjon/RenovationComponent.js"></script>
        <link href="https://norkartrenovasjon.azurewebsites.net/Stylesheet/Renovation-1.3-min.css" rel="stylesheet" />
        <script type="text/javascript">// <![CDATA[
            function onLoad() {
                         
                            var options =
                            {
                                height: 500, 
                                backgroundColor: '#f6f6f6',
                                fontFamily: 'Arial',
                                fontSize: '16px',
                                fontColor: 'black',
                                onfocusColor: '#51A026',
                                activeTabColor: '#f6f6f6',
                                inactiveTabColor: '#8CC961',
                                hideThreeLastFans: false,
                                hideFourLastFans: false,
                                kommunesamarbeid: true,
                                kommunenummere: ["${kommuneNr}"],
                                cptBackgroundColor: 'white',
                                searchSeveralMunicipalitiesAtOnce: true,
                                innbyggerMelding: true,
                                zoomLevel: 14
                            };
            
                            var renovation = new RenovationCpt('renovation', options);
                            renovation.execute();
                        
                        }
            document.addEventListener("DOMContentLoaded", function(event) {
                  onLoad();
              });
            // ]]>
        </script>
        <div id="renovation"></div>
    `;
};
